<template>
  <main>
    <div class="gp-wrapper px-0 px-sm-1 px-md-2 px-lg-0 px-xl-6 px-mlg-2 bg-light-grey-300" ref="mainBody" id="mainBody" v-if="agencyInfo">
      <Modal v-if="notiAction.isViewingNoti" :preventBackdrop="true" @cancel="closeNoti()" :cClass="notiModalClass" closeClass="extend-trial-close" :noBreakLine="notiAction.noti.settings['extend-trial'] ? true : false" :hideExit="notiAction.noti.settings['extend-trial'] ? false : true" mClass="p-4 pt-6" iClass="typo-icon-25 p12">
        <template #header v-if="notiAction.noti.settings['extend-trial'] ? false : true">
          <div class="noti-exit p-1 d-flex clickable" @click="closeNoti()">
            <i class="icon icon-cancel ml-auto"></i>
          </div>
          <div v-if="notiAction.noti.settings['extend-trial'] ? false : true" class="typo-heading20 typo-medium text-light-high" v-html="notiTitle"></div>
        </template>
        <template #default>
          <div class="extend-trial-content" v-html="notiContent"></div>
          <div class="btn-group flex-row-reverse">
            <button @click="gotoUpgrade()" v-if="notiAction.noti.settings.upgrade_button" class="btn btn-primary">{{ $t("modals.noti.upgrade_button") }}</button>
            <button @click="gotoHelpCenter()" v-if="notiAction.noti.settings.help_center_button" class="btn btn-outline btn-invert">
              <svg class="mr-1" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4.5" cy="4.5" r="4" fill="#06E884" />
              </svg>
              {{ $t("modals.noti.help_center_button") }}
            </button>
          </div>
        </template>
      </Modal>

      <Navigator />
      <div ref="gpMainBody" class="container gp-main-body px-1 px-xs-2 px-sm-4 px-md-5 px-xl-6 px-lg-2 px-mlg-2">
        <div class="gp-main-body-wrapper">
          <div class="col-lg-12" v-if="headerVisible">
            <header class="row pb-2">
              <div class="col-12 col-sm-8 col-lg-7 col-xl-8">
                <div class="row">
                  <div class="shop-info">
                    <h2 class="flex-v-center typo-heading24 typo-semibold">{{ headerTitleText }}</h2>
                    <p class="typo-button14 typo-medium text-light-low mt-sm-1" v-if="headerDescription">{{ headerDescriptionText }}</p>
                    <p class="typo-paragrap14 typo-regular text-light-low" v-if="headerSubtitle">{{ headerSubtitleText }}</p>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-4 col-lg-5 col-xl-4 d-flex flex-column-reverse">
                <PortalTarget class="row" name="headerActions" multiple />
              </div>
            </header>

            <section class="row pb-2" v-if="breadcrums != undefined && breadcrums.length > 0">
              <div class="typo-h5 flex-v-center breadcrumb row">
                <template v-for="(item, index) in breadcrums">
                  <router-link replace class="rl" :to="{ name: item.to }" :key="`breadcrumb-link-${index}`" v-if="item.to != undefined">{{ item.name }}</router-link>
                  <router-link replace class="rl" :to="{ name: item.to }" :tag="item.to ? 'a' : 'span'" :key="`breadcrumb-link-${index}`" v-else>{{ item.name }}</router-link>
                  <i class="icon icon-arrow-right" v-if="item.to != undefined" :key="`breadcrumb-arrow-${index}`" />
                </template>
              </div>
            </section>
          </div>

          <router-view />
        </div>
      </div>
    </div>
    <PortalTarget name="modals" multiple></PortalTarget>
    <Sidebar v-if="agencyInfo" mode="agency" />
    <PortalTarget name="tooltips" multiple></PortalTarget>
    <template v-if="gSnackbar.message != '' && gSnackbar.type != ''">
      <GSnackBar :message="gSnackbar.message" :type="gSnackbar.type" />
    </template>

    <GLoading class="sync-with-editor" hasFrame :size="gLoadingSize" :noOverlay="false" v-if="gLoadingActive">
      <template #text>
        {{ gLoadingText }}
      </template>
    </GLoading>
  </main>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { Sidebar } from "@/core/components";

import getLocale from "@/mixins/getLocale.js";
import { readI18n } from "@/i18n.js";

export default {
  name: "AgencyRoot",
  components: {
    Sidebar,
  },
  mixins: [getLocale],
  data() {
    return {
      headerVisible: true,
      headerTitle: "Hello, GemPages",
      headerDomain: "",
      headerSubtitle: "",
      headerDescription: "",
      headerEnableBreadcrum: false,
      breadcrums: [],

      alertCount: null
    };
  },
  computed: {
    ...mapState({
      sidebarOpening: state => state.drawer.opening
    }),
    ...mapState("agency", {
      agencyLogged: state => state.logged,
      agencyInfo: state => state.info
    }),
    ...mapGetters("common", {
      gLoading: "gLoading",
      gSnackbar: "gSnackbar"
    }),
    ...mapGetters("notibar", {
      sticky: "sticky",
      notiAction: "noti_action",
      last_system_noti: "last_system_noti"
    }),
    noti() {
      if (this.last_system_noti && this.last_system_noti[0]) {
        return this.last_system_noti[0];
      }
      return undefined;
    },
    notiModalClass() {
      if (this.notiAction.noti.settings) {
        return "mw950" + (this.notiAction.noti.settings["extend-trial"] ? " extend-trial bg-white" : "");
      }
      return "mw950";
    },
    gLoadingSize() {
      return this.gLoading.size;
    },
    gLoadingActive() {
      return this.gLoading.active;
    },
    gLoadingText() {
      return this.gLoading.text;
    },
    headerTitleText() {
      return readI18n(this, this.headerTitle);
    },
    headerSubtitleText() {
      return readI18n(this, this.headerSubtitle);
    },
    headerDescriptionText() {
      return readI18n(this, this.headerDescription);
    },
    notiContent() {
      return this.getLocaleText(this.notiAction.noti.content);
    },
    notiTitle() {
      return this.getLocaleText(this.notiAction.noti.title);
    }
  },
  watch: {
    "$route.meta": {
      deep: true,
      handler(meta) {
        setTimeout(() => {
          this.setMeta(meta);
        }, 0);
      }
    }
  },
  created() {
    this.getAgency().then(() => {
      let agency = JSON.parse(JSON.stringify(this.agencyInfo));
      if (Object.entries(agency).length === 0 && agency.constructor === Object) {
        // let url = window.location.href;
        // let arr = url.split("/");
        // let host = arr[0] + "//" + arr[2];
        // window.location.href = host + "/agency/login"
      }
    });
    this.$body = this.$refs.mainBody;
    this.setMeta();
  },
  mounted() {},
  methods: {
    ...mapActions("agency", {
      getAgency: "getAgency"
    }),
    ...mapActions("notibar", {
      toogleStickyModal: "toogleSticky",
      closeStickyModal: "closeModalNoti",
      showModalNoti: "showModalNoti",
      trackAction: "trackAction"
    }),
    ...mapMutations("agency", {
      updateSearch: "AGENCY_CHANGE_SEARCH"
    }),
    setMeta(meta = this.$route.meta) {
      if (meta.headerVisible !== undefined) {
        this.headerVisible = meta.headerVisible;
      }

      if (meta.headerTitle !== undefined) {
        this.headerTitle = meta.headerTitle;
      }
      if (meta.headerDescription !== undefined) {
        this.headerDescription = meta.headerDescription;
      } else {
        this.headerDescription = null;
      }

      if (meta.headerDomain !== undefined) {
        this.headerDomain = meta.headerDomain;
      }

      if (meta.headerSubtitle !== undefined) {
        this.headerSubtitle = meta.headerSubtitle;
      } else {
        this.headerSubtitle = null;
      }

      if (!meta.breadcrums) {
        this.breadcrums = [];
      } else {
        this.breadcrums = meta.breadcrums;
      }

      if (meta && meta.scrollTop != undefined && this.$refs.mainBody) {
        this.$refs.mainBody.scrollTop = 0;
      }
    },
    closeNoti() {
      this.closeStickyModal();
    },
    gotoHelpCenter() {
      this.$chatbox.show();
    },
    gotoUpgrade() {
      this.$router.replace({ name: "Pricing" });
    },
    searchShop(e) {
      this.queryShop = e;
    },
    onSearchChange(params) {
      this.updateSearch(params.value);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .extend-trial {
  .d-flex {
    > svg {
      flex-shrink: 0;
    }
  }
  position: relative;
  &-close {
    position: absolute;
    top: 36px;
    right: 36px;
  }
  &-h1 {
    background: linear-gradient(0deg, #ffd028 -11.54%, #fbeaae 111.24%);
    font-size: 87px;
    line-height: 125px;
    width: 100px;
    text-align: center;
    .depth {
      // color: transparent;
      // text-shadow: 2px 2px 3px rgba(255, 255, 255, 0.2);
      // -webkit-background-clip: text;
      // -moz-background-clip: text;
      // background-clip: text;
      &-important {
        color: rgba(236, 54, 54, 0.8);
        text-shadow: 1px 2px 4px #ffbdbd, 0 0 0 #000, 0px 1px 4px #ffbdbd;
      }
      &-normal {
        color: rgba(9, 63, 255, 0.8);
        text-shadow: 1px 1px 6px #c3d0ff, 0 0 0 #000, 0px 1px 1px #c3d0ff;
      }
    }
  }
  &-h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 130%;
    /* or 62px */

    letter-spacing: -0.005em;
    text-transform: uppercase;
  }
  &-h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: -0.005em;
    text-transform: capitalize;
  }
  &-img {
    max-width: 100%;
    > img {
      width: 120%;
      transform: translateX(-8%);
    }
  }

  &-14 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
  }

  &-16 {
    font-style: normal;
    font-size: 16px;
    line-height: 130%;
  }

  &-32 {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 130%;
    letter-spacing: -0.005em;
  }

  &-60 {
    font-style: normal;
    font-weight: bold;
    font-size: 60px;
    line-height: 44px;
    letter-spacing: -0.005em;
    margin-bottom: 16px;
  }
  .extend-trial-content {
    position: relative;
    z-index: -1;
  }
  .btn-group {
    // position: absolute;
    // bottom: 48px;
    // right: 80px;
    margin-top: -64px;
    margin-right: 16px;
    z-index: 1;
    .btn {
      margin-left: 24px;
      width: 200px;
      height: 40px;
      &-invert {
        color: $textLightModeHigh;
        background: $light3;
        border: $light3;
      }
    }
  }
}
.noti-exit {
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: $radius;
  transition: all ease 0.3s;
  &:hover {
    background: $textDarkModeHigh;
  }
}

.global-loading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99999;

  ::v-deep {
    .gfLoader {
      background-color: rgba(#000, 0.7);

      &-frame-medium {
        $size: 120px;
        width: $size;
        height: $size;
      }
    }
  }
}

.login-btn {
  color: $cSecondary4;
  font-size: 14px;
  line-height: 21px;
  text-decoration-line: underline;
}
.login-btn:hover {
  cursor: pointer;
}

.shop-info {
  // cursor: pointer;
  .shop-logo img {
    height: 40px;
  }
  .shop-name {
    line-height: 30px;
    margin-bottom: 6px;
  }
  .domain {
    display: inline-block;
    @include trans-all;

    &:hover {
      color: $cPrimary;
    }
  }
}

::v-deep .gp_modal-container.maxw-80p {
  width: 80%;
  max-width: 1000px;
  min-width: 320px;
}

::v-deep .gp_modal-container.maxw-50p {
  width: 70%;
  max-width: 750px;
  min-width: 320px;
}

@media only screen and (max-width: 767px) {
  html {
    overflow: hidden;

    main {
      display: flex;
      flex-direction: column;
    }

    .gp-wrapper {
      .bb1sg {
        display: none;
      }

      .gp-main-body-wrapper {
        // margin-top: 60px;
        padding-bottom: 16px;
        padding-left: 8px;
        padding-right: 8px;

        header {
          .row {
            justify-content: center;
          }

          .shop-info {
            height: 100%;
            width: 100%;
            text-align: center;

            h2 {
              font-weight: 600;
              font-size: 28px;
              line-height: 42px;
              // margin-bottom: 40px;
              // padding: 0 24px;
              // color: #ffffff;
            }
            p {
              text-align: left;
            }
          }
        }
      }
    }

    #gp-intercom {
      bottom: 70px !important;
    }
  }
}

@media only screen and (max-width: 575px) {
  ::v-deep .gp_modal-container.maxw-80p {
    width: 100%;
  }
  .long-desc.hide-text {
    min-height: 100px;
  }
}

@media (min-width: 1280px) {
  ::v-deep .close-class {
    position: absolute;
    top: 100px;
    right: 100px;
    padding: 12px;
  }
}

.sync-with-editor {
  ::v-deep .gfLoader-frame-large {
    width: 120px;
    height: 120px;
    transform: translateY(-22px);
  }
}
</style>
